import { Component, OnInit, Renderer2, ViewEncapsulation } from '@angular/core';
import { ApiService } from "../../core/services/api.service";
import { environment } from '../../../environments/environment';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthService } from '../../core/auth/auth.service';
import { UserService } from 'src/app/core/services/user.service';
import { AudioService } from 'src/app/core/services/audio.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'app-keertan',
  templateUrl: './keertan.component.html',
  styleUrls: ['./keertan.component.scss'],
  encapsulation: ViewEncapsulation.None // Disable encapsulation
})
export class KeertanComponent implements OnInit {
  userDetails: any = [];
  loader: boolean = false;
  language: boolean = false;
  sortColumn: any = '';
  sortReverse: boolean = false;
  selectedLyrics = 0;
  selectedLyric:any;
  keertanCode: string = '';
  keertanId: any = "";
  listsData: any = [];
  listsLyrics: any = [];
  audios: any = [];
  listsDataDropdown: any = [];
  artistConfig: any;
  public artistOptions: any;
  songIndex: any;
  palyedSong: any;
  routeFlag: string;

  public pageTypeData: any = [{ id: 1, description: 'Audio', value: 1 }, { id: 2, description: 'Album', value: 2 }];

  constructor(private apiService: ApiService, private authService: AuthService, private router: Router,
    private renderer: Renderer2,
    private audioService: AudioService,
    private route: ActivatedRoute,
    private userService: UserService, private sanitizer: DomSanitizer) {
    this.artistConfig = {
      displayKey: 'description',
      search: true,
      height: 'auto',
      placeholder: 'search',
      customComparator: () => { },
      limitTo: 0,
      moreText: 'more',
      noResultsFound: 'No Artist found!',
      searchPlaceholder: 'serach artist',
      searchOnKey: 'name',
      clearOnSelection: true,
      inputDirection: 'ltr'
    };
  }


  copyText(englishText: string, hindiText: string): void {
 
    let textToCopy:string="";
    this.listsLyrics.forEach((item:any) => {
      if (!this.language) {
        textToCopy += (item && item.line_text) + "\n";  
        textToCopy += (item && item.line_meaning) + "\n\n";  
      } else {
        textToCopy += (item && item.translations && item.translations.line_text) + "\n"; 
        textToCopy += (item && item.translations && item.translations.line_meaning) + "\n\n";  
      }
    });
  
    if (textToCopy) {
      const textarea = document.createElement('textarea');
      textarea.value = textToCopy;
      document.body.appendChild(textarea);
      textarea.select();
      try {
        document.execCommand('copy'); 
      } catch (err) {
        console.error('Could not copy text: ', err);
        alert('Failed to copy text.');
      } finally {
        document.body.removeChild(textarea);
      }
    } else {
      alert('No text to copy!');
    }
  }

  
  highlightWord(text: string, words: string): string {
    if (!text || !words) {
      return text; // Return original text if there’s nothing to process
    }

    // Split the words into an array
    const wordList = words.split(' ').filter(word => word.trim().length > 0);

    // Escape special regex characters for each word
    const escapedWords = wordList.map(word => word.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'));

    // Create a regex to match any of the words
    const regex = new RegExp(`(${escapedWords.join('|')})`, 'gi'); // Match any word, case-insensitive

    // Replace matched words with highlighted spans
    return text.replace(regex, `<span class="highlight">$1</span>`);
  }


  restrictInput(event: KeyboardEvent) {
    // Prevent entering '_' or ' ' (space)
    if (event.key === ' _' || event.key === '_ ' || event.key === ' _ ') {
      event.preventDefault();
    }
  }

  getAdviser = () => {
    this.loader = true;
    this.apiService
      .callGetAPI("v2/customer/subscription", environment.userApiUrl)
      .subscribe(
        (data) => {
          this.loader = false;
          if (data['response'].is_keertan_viewer != 1) {
            this.router.navigate(['404']);
            return false;
          }
        },
        (error) => {
          this.apiService.failureResponse(error, true);
        }
      );
  }




  ngOnInit() { 
    this.route.queryParamMap.subscribe(params => {
      const token = params.get('token'); // Get the token from the URL
      this.routeFlag = token; 
    }); 

    this.getAdviser();
    document.addEventListener("keydown", this.disableInspectTools, false);
    this.getTitle()

    this.audioService.songState$.subscribe(res => {
      if (res === 'play') {
        this.updateSongIndex();
      } else if (res === 'pause') {
        this.songIndex = null;
      }
    });

  }

  playSong(song: any, i: any) {
    // if (this.checkUser()) {
    //   if (localStorage.getItem('currentUser')) {
    localStorage.setItem('queueList', JSON.stringify(this.audios));
    this.audioService.setData({
      'songList': this.audios,
      'selectedindex': i
    });
    this.audioService.newStateSong('play');
    this.songIndex = i;
    this.palyedSong = song;
    //   } else {
    //     this.userService.displayPopup('sign-in');
    //     return false;
    //   }
    // }
  }

  pushedSong() {
    const button = document.getElementById("player-close");
    if (button) {
      button.click();
    }
  }

  checkUser() {
    // Single audio play gate: sign-in, then subscription OR remaining
    // free minutes. See AudioService.canPlayAudio().
    return this.audioService.canPlayAudio();
  }

  generateTable() {
    const ulElements = document.querySelectorAll('#content-to-download ul');

    // HTML content generation
    let tableHTML = `
      <table border="1" style="width: 100%; border-collapse: collapse;">
        <thead>
          <tr>
            <th>Hindi Title</th>
            <th>English Title</th>
            <th>Hindi Meaning</th>
            <th>English Meaning</th>
          </tr>
        </thead>
        <tbody>
    `;

    // CSV content generation
    const headers = ['Hindi Title', 'English Title', 'Hindi Meaning', 'English Meaning'];
    const rows = [];

    // Convert headers and rows to CSV format with UTF-8 BOM
    ulElements.forEach((ul) => {
      const hindiTitle = ul.querySelector('.lyrics_title_hindi') ? ul.querySelector('.lyrics_title_hindi').textContent : '';
      const englishTitle = ul.querySelector('.lyrics_title_english') ? ul.querySelector('.lyrics_title_english').textContent : '';
      const hindiMeaning = ul.querySelector('.lyrics_meaning_hindi') ? ul.querySelector('.lyrics_meaning_hindi').textContent : '';
      const englishMeaning = ul.querySelector('.lyrics_meaning_english') ? ul.querySelector('.lyrics_meaning_english').textContent : '';
      const datarow = [hindiTitle, englishTitle, hindiMeaning, englishMeaning];
      rows.push(datarow);
      // Add row to HTML table
      tableHTML += `
        <tr>
          <td>${hindiTitle}</td>
          <td>${englishTitle}</td>
          <td>${hindiMeaning}</td>
          <td>${englishMeaning}</td>
        </tr>
      `;
    });
    let csvContent = '\uFEFF'; // UTF-8 BOM for Hindi character support
    csvContent += headers.join(',') + '\n'; // Add header row
    rows.forEach(row => {
      csvContent += row.map(item => `"${item}"`).join(',') + '\n'; // Wrap each item in quotes to handle commas
    });

    tableHTML += `</tbody></table>`;

    // Trigger downloads for both HTML and CSV
    this.downloadAsFile(tableHTML, 'sankeertan-search-data.html', 'text/html');
    this.downloadAsFile(csvContent, 'sankeertan-search-data.csv', 'text/csv');
  }

  downloadAsFile(content: string, filename: string, contentType: string) {
    const blob = new Blob([content], { type: `${contentType};charset=utf-8` });
    const downloadLink = document.createElement('a');
    downloadLink.href = URL.createObjectURL(blob);
    downloadLink.download = filename;
    downloadLink.click();
    URL.revokeObjectURL(downloadLink.href);
  }

  disableInspectTools(event: KeyboardEvent): void {
    // Disable F12 key
    if (event.key === "F12") {
      event.preventDefault();
    }
    // Disable Ctrl+Shift+I (Inspect)
    if (event.ctrlKey && event.shiftKey && event.key === "I") {
      event.preventDefault();
    }
    // Disable Ctrl+Shift+C (Element picker)
    if (event.ctrlKey && event.shiftKey && event.key === "C") {
      event.preventDefault();
    }
  }

  ngOnDestroy(): void {
    document.removeEventListener("keydown", this.disableInspectTools, false);
  }

  handleLanguage = () => {
    this.language = !this.language;
  }

  getValue(obj, path) {
    return path.split('.').reduce((o, p) => o ? o[p] : '', obj);
  }

  sortTable = function (column) {
    if (this.sortColumn === column) {
      this.sortReverse = !this.sortReverse;
    } else {
      this.sortColumn = column;
      this.sortReverse = false;
    }

    this.listsData.sort((a, b) => {
      let valueA = this.getValue(a, column);
      let valueB = this.getValue(b, column);

      if (valueA < valueB) {
        return this.sortReverse ? 1 : -1;
      } else if (valueA > valueB) {
        return this.sortReverse ? -1 : 1;
      } else {
        return 0;
      }
    });
  };

  handleGetLyrics = (e: number) => {
    this.selectedLyrics = e;
    this.getLyris()
  }

  handleGetLyricsData = (e:any) => {
    this.selectedLyric = e;
  }

  getKeertan = (event: Event) => { 
    this.keertanCode = "";
    this.getSearch()
  }

  onSubmit() { 
    this.keertanId = "";
    if(this.keertanCode.length >= 2)
    {
      this.getSearch()
    }else{
      this.listsData = [];
    }
    
  }

  onChnageKeertan() { 
    this.keertanId = "";
    if(this.keertanCode.length >= 2)
      {
        this.getSearch()
      }else{
        this.listsData = [];
      }
  }

  getTitle() {
    const apiUrl = 'v2/keertanTitle/lists';
    this.loader = true;
    this.apiService
      .callPostAPI(apiUrl, {}, environment.userApiUrl)
      .subscribe(
        (data: any) => {
          this.loader = false;
          this.listsDataDropdown = data.data
          console.log(data)
        },
        (error) => {
          this.apiService.failureResponse(error, true);
        }
      );
  }

  getSearch() {
    const apiUrl = 'v2/keertanTitle/lists';
    this.loader = true;
    const s = {
      search_term: this.keertanCode,
      id: this.keertanId
    }

    this.apiService
      .callPostAPI(apiUrl, s, environment.userApiUrl)
      .subscribe(
        (resp: any) => {
          this.loader = false;
          this.listsData = resp.data
          this.listsLyrics = [];
          this.audios = [];
          this.selectedLyrics = 0;
          this.selectedLyric = null;
          if (resp.data.length == 1) {
            this.selectedLyrics = resp.data[0].id;
            this.selectedLyric = resp.data[0];
            this.getLyris()
          }
          console.log(resp)
        },
        (error) => {
          this.apiService.failureResponse(error, true);
        }
      );
  }

  getLyris() {
    const apiUrl = 'v2/keertanLyrics/lists';
    this.loader = true;
    const s = {
      id: this.selectedLyrics
    }

    this.apiService
      .callPostAPI(apiUrl, s, environment.userApiUrl)
      .subscribe(
        (resp: any) => {
          this.loader = false;
          this.listsLyrics = resp.data;
          this.audios = resp.audios
          console.log(resp)
          this.updateSongIndex()

          const button = document.getElementById("player-close");
          if (button) {
            button.click();
          }

        },
        (error) => {
          this.apiService.failureResponse(error, true);
        }
      );
  }


  updateSongIndex() {
    const id = this.audioService.getCurrentPlayingSongId();
    this.songIndex = this.audios.findIndex((value) => value.id === id);
  }

}
